/***************************************************************
 * Copyright (c) 2006 - 2022, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 04/01/2022
 *
 * @version 0.1
 * Revisions:
 * 04/01/2022 - BW - Initial Creation
 *
 * Description/Purpose:
 * Payment Extra Validation
 ***************************************************************/
import {COMMON, VALIDATION_MESSAGE} from "page/payment/payment-extra-util";
import {ValidateFormUtil} from "util/validate-form-util";

export default class PaymentExtraValidation {

    /**
     *
     * @param _validationForm
     * @returns {PaymentExtraValidation}
     */
    constructor(validationForm, options = []) {
        this._validationForm = validationForm;
        const defaults = {
        };
        // extends config
        this.opts = $.extend(true, defaults, options);
        return this;
    }


    /**
     * Adds the dynamic validation rules for when users add/remove bates range entries
     * @param validateForm
     * @param addPaymentExtraValidationDB
     */
    addDynamicValidation(validateForm, addPaymentExtraValidationDB) {
        let paymentExtraSSV = '';
        const paymentExtraRuleObj = {};
        const paymentExtraMessageObj = {};

        $(`.${COMMON.PAYMENT_EXTRA_LI_DATA_CLASS}`).each((index, value) => {
            const $this = $(value);

            // Check to see if this LI is an "ACTUAL ROW" (needed data)
            if (this._validateActualRow($this)) {
                // Grab each "required" input ( being and end)
                const $invoiceNumber = $this.find(`.${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT}`);
                const invoiceNumberName = $invoiceNumber.attr('name');
                const $invoiceNumberValid = $this.find(`.${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT_VALID}`);
                const $payment = $this.find(`.${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}`);
                const paymentName = $payment.attr('name');

                // Process the group data first
                paymentExtraSSV += paymentExtraSSV.length > 0 ? ' ' : '';
                paymentExtraSSV += `${invoiceNumberName} ${paymentName}`;

                // Next add the rules for each element
                paymentExtraRuleObj[invoiceNumberName] =
                    {
                        required: true,
                        validateInvoiceNumber: true,
                    };
                paymentExtraRuleObj[paymentName] =
                    {
                        required: true,
                        currency: true,
                        validatePayment: true,
                        validatePaymentFlashDrive: true,
                    };

                // Finally add the messages for each element
                paymentExtraMessageObj[invoiceNumberName] =
                    {
                        required: VALIDATION_MESSAGE.INVOICE_NUMBER_PAYMENT_REQUIRED,
                        validateInvoiceNumber: VALIDATION_MESSAGE.INVOICE_NUMBER_NOT_FOUND,
                    };
                paymentExtraMessageObj[paymentName] =
                    {
                        required: VALIDATION_MESSAGE.PAYMENT_REQUIRED,
                        currency: VALIDATION_MESSAGE.PAYMENT_CURRENCY,
                        validatePayment: VALIDATION_MESSAGE.PAYMENT_MORE_THAN_BALANCE,
                        validatePaymentFlashDrive: VALIDATION_MESSAGE.FLASH_DRIVE,
                    };
            }
        });

        // Add to the ValidationForm if necessary
        if (paymentExtraSSV.length > 0) {
            validateForm
                .addGroups({paymentExtraGroup: paymentExtraSSV})
                .addRules(paymentExtraRuleObj)
                .addMessages(paymentExtraMessageObj)
            // .init();
            console.log( this._validationForm );
            ValidateFormUtil.addCurrency();
            ValidateFormUtil.addValidateInvoiceNumber();
            ValidateFormUtil.addValidatePayment();
            ValidateFormUtil.addValidatePaymentFlashDrive();
        }
    }


    /**
     * Will determine if this row is a row the user is actually trying to submit (ie: a 'real' row)
     * @param $this
     * @returns {boolean}
     * @private
     */
    _validateActualRow($this) {
        this.__validateActualRow = true; // eslint
        const $invoiceNumber = $this.find(`.${COMMON.PAYMENT_EXTRA_INVOICE_NUMBER_INPUT}`);
        const invoiceNumberValue = $invoiceNumber.val();
        const $payment = $this.find(`.${COMMON.PAYMENT_EXTRA_PAYMENT_INPUT}`);
        const paymentValue = $payment.val();
        // The begin and end are the only required value
        return (invoiceNumberValue !== undefined && invoiceNumberValue.length > 0)
            || (paymentValue !== undefined && paymentValue.length > 0);
    }

}
